<template>
  <v-container>
    <v-layout align-center fill-height column overflow-hidden>
        <v-layout row shrink class="ma-4" >
          <h1 class="display-3 font-weight-black">Welcome</h1>
        </v-layout>
        
        <v-card class="mb-5"  color="grey lighten-3" elevation="0">
          <v-container fluid grid-list-lg>
            <v-card>
              <v-container>
                <h3>Organization</h3>
                <p>Your Organization will group your store fronts, employees, products, billing and more.</p>
                <v-text-field
                label="Organization Name"
                v-model="Organization.name"
                :error-messages="organizationNameErrors"
                hint="ie. Unlimited Repair Stores, 99 Cent Franchise, One Team Stores, Verizon Prepaid Stores"
                ></v-text-field>

                <v-text-field
                v-model="Organization.phoneNumber"
                label="Phone number"
                :error-messages="organizationPhoneNumberErrors"
                hint="ie. Headquater Office Number, Owners phone number, etc"
                >
                </v-text-field>

                <v-text-field
                v-model="Organization.email"
                label="Email"
                :error-messages="organizationEmailErrors"
                hint="This email will receive information about all business under this Organization."
                >
                </v-text-field>
              </v-container>
            </v-card>
            
            <v-card class="mt-3">
              <v-container>
                <h3>Your first location</h3>
                <p>Enter the business information for the first location/store front you would like to start with. If you're signing up more than one location,
                  enter the location you consider as your main business and enter the rest after your organization set up is complete. <b>This information
                  will be printed on the business invoice receipts.</b></p>
                
                <v-text-field
                v-model="Location.name"
                label="Business Name"
                :error-messages="locationNameErrors"
                hint="ie. CellSmart Wireless LLC, El Primo Repairs, Great Deli #4"
                >
                </v-text-field>

                <v-text-field
                v-model="Location.website"
                label="Website"
                >
                </v-text-field>
                
                <v-layout row wrap>
                  <v-flex xs6>
                    <v-text-field
                    v-model="Location.DCALicense"
                    label="DCA License"
                    >
                    </v-text-field>
                  </v-flex>
                  
                  <v-flex xs6>
                    <v-text-field
                    v-model="Location.email"
                    :error-messages="locationEmailErrors"
                    label="Email"
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs6>
                    <v-text-field
                    v-model="Location.type"
                    label="Type"
                    >
                    </v-text-field>
                  </v-flex>
                  
                  <v-flex xs6>
                    <v-text-field
                    readonly
                    v-model="Location.timeZone"
                    label="Time Zone"
                    >
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <h4>Address</h4>

                <v-layout row wrap>
                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      type="text"
                      v-model="Location.Address.type"
                      @focus="$event.target.select()"
                      :label="$t('labels.type')"
                      hint="ie. Home, Office, Bussiness"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      type="text"
                      v-model="Location.Address.phoneNumber"
                      @focus="$event.target.select()"
                      :label="$t('labels.phoneNumber')"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      type="text"
                      v-model="Location.Address.addressLine1"
                      :error-messages="addressLine1Errors"
                      :label="$t('labels.address')"
                      @focus="$event.target.select()"
                      @input="$v.Location.Address.addressLine1.$touch()"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      type="text"
                      v-model="Location.Address.addressLine2"
                      @focus="$event.target.select()"
                      :label="$t('labels.addressLine2')"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      type="text"
                      v-model="Location.Address.city"
                      :error-messages="cityErrors"
                      :label="$t('labels.city')"
                      @focus="$event.target.select()"
                      @input="$v.Location.Address.city.$touch()"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-select
                    :items="states"
                    :label="$t('labels.state')"
                    :error-messages="stateIdErrors"
                    item-text="name"
                    item-value="id"
                    v-model="Location.Address.StateId"></v-select>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                    <v-text-field
                      type="text"
                      :error-messages="postalCodeErros"
                      v-model="Location.Address.postalCode"
                      :label="$t('labels.zipCode')"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md6>
                      <v-select
                      :items="countries"
                      :error-messages="countryCodeErrors"
                      :label="$t('labels.country')"
                      item-text="name"
                      item-value="code"
                      v-model="Location.Address.CountryCode"
                    ></v-select>
                  </v-flex>

                  <v-flex xs12>
                    <v-textarea
                      name="input-7-1"
                      :label="$t('labels.description')"
                      auto-grow
                      v-model="Location.Address.description"
                      hint="Any notes you would like to save about this location."
                    ></v-textarea>
                  </v-flex>

                  

                </v-layout>
              </v-container>
            </v-card>

            <v-layout justify-end row class="mt-3">
              <v-btn color="primary" flat to="/login" >{{ $t('buttons.cancel') }}</v-btn>
              <v-btn color="primary" @click="submit" :loading="isLoading">{{ $t('buttons.createOrganization') }}</v-btn>
            </v-layout>
            

          </v-container>
        </v-card>
      
    </v-layout>
  </v-container>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import organizationService from '../Organization/service.js'

const { validationMixin } = require('vuelidate')
const {
  required,
  minLength,
  email,
  requiredIf,
} = require('vuelidate/lib/validators')

export default {
  name: 'new-organization',
  data() {
    return {
      isLoading: false,
      ReferralCode: null,
      Organization: {
        name: null,
        phoneNumber: null,
        email: null,
      },
      Location: {
        name: null,
        type: null,
        website: null,
        DCALicense: null,
        timeZone: this.$moment.tz.guess() || 'America/New_York',
        email: null,
        Address: {
          name: null,
          addressLine1: null,
          addressLine2: null,
          addressLine3: null,
          city: null,
          StateId: null,
          CountryCode: null,
          phoneNumber: null,
        },
      },
      taxTemplate: {
        name: null,
        autoApply: false,
        symbol: null,
        type: 'PERCENTAGE',
        percentage: null,
        amount: null,
      },
    }
  },
  methods: {
    ...mapActions('global', ['initOrganization']),
    submit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$swal.mixin({
          toast: true,
          position: 'top-end',
          showConfirmButton: false,
          timer: 3000
        }).fire({
          type: 'error',
          title: 'Invalid Input'
        })
      } else {
        this.isLoading = true
        organizationService.create({
          ReferralCode: this.ReferralCode,
          Organization: this.Organization,
          Location: this.Location,
        })
          .then((response) => {
            return this.initOrganization(response.data)
              .then(() => {
                this.$router.push({ path: '/' })
              })
              .catch((error) => {
                console.log(error)
              })
            this.isLoading = false
          })
          .catch((error) => {
            console.log(error)
            this.isLoading = false
          })
      }
    },
  },
  computed: {
    ...mapGetters('global', [
      'states',
      'countries',
      'defaultCountryCode',
    ]),
    organizationNameErrors() {
      const errors = []
      if (!this.$v.Organization.name.$dirty) return errors
      if (!this.$v.Organization.name.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.Organization.name.minLength) errors.push(this.$t('validations.fieldMustbeatLeast4ChrLong'))
      return errors
    },
    organizationPhoneNumberErrors() {
      const errors = []
      if (!this.$v.Organization.phoneNumber.$dirty) return errors
      if (!this.$v.Organization.phoneNumber.required) errors.push(this.$t('validations.phoneNumberIsRequired'))
      if (!this.$v.Organization.phoneNumber.minLength) errors.push(this.$t('validations.invalidPhoneNumber'))
      return errors
    },
    organizationEmailErrors() {
      const errors = []
      if (!this.$v.Organization.email.$dirty) return errors
      if (!this.$v.Organization.email.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.Organization.email.email) errors.push(this.$t('validations.emailIsNotValid'))
      return errors
    },
    locationNameErrors() {
      const errors = []
      if (!this.$v.Location.name.$dirty) return errors
      if (!this.$v.Location.name.required) errors.push(this.$t('validations.fieldIsRequired'))
      if (!this.$v.Location.name.minLength) errors.push(this.$t('validations.fieldMustbeatLeast4ChrLong'))
      return errors
    },
    locationEmailErrors() {
      const errors = []
      if (!this.$v.Location.email.$dirty) return errors
      if (!this.$v.Location.email.email) errors.push(this.$t('validations.emailIsNotValid'))
      return errors
    },
    addressLine1Errors() {
      const errors = []
      if (!this.$v.Location.Address.addressLine1.$dirty) return errors
      if (!this.$v.Location.Address.addressLine1.minLength) errors.push(this.$t('validations.addressMustHaveAtleast2Characters'))
      if (!this.$v.Location.Address.addressLine1.required) errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    cityErrors() {
      const errors = []
      if (!this.$v.Location.Address.city.$dirty) return errors
      if (!this.$v.Location.Address.city.required) errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    postalCodeErros() {
      const errors = []
      if (!this.$v.Location.Address.postalCode.$dirty) return errors
      if (!this.$v.Location.Address.postalCode.required) errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    stateIdErrors() {
      const errors = []
      if (!this.$v.Location.Address.StateId.$dirty) return errors
      if (!this.$v.Location.Address.StateId.required) errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
    countryCodeErrors() {
      const errors = []
      if (!this.$v.Location.Address.CountryCode.$dirty) return errors
      if (!this.$v.Location.Address.CountryCode.required) errors.push(this.$t('validations.fieldIsRequired'))
      return errors
    },
  },
  mixins: [validationMixin],
  validations: {
    Organization: {
      name: {
        required,
        minLength: minLength(4),
      },
      phoneNumber: {
        required,
        minLength: minLength(10),
      },
      email: {
        required,
        email,
      },
    },
    Location: {
      name: {
        required,
        minLength: minLength(4),
      },
      email: {
        email,
      },
      Address: {
        addressLine1: {
          required,
          minLength: minLength(2),
        },
        city: {
          required,
        },
        postalCode: {
          required,
        },
        StateId: {
          required,
        },
        CountryCode: {
          required,
        },
      },
    },
  },
}
</script>
